module.exports = __webpack_public_path__ + "img/fillister_head_sku.prt.11a0663e.jpg";